import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageAction, PoPageFilter, PoSearchFilterMode, PoSelectOption, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { RomaneioService } from 'src/app/estoque/romaneio/service/romaneio.service';
import { ExcelService } from 'src/app/service/excel-service';
import { FiltroControleQualidadeLista } from '../../filter/filtro-controle-qualidade-lista';
import { ControleQualidadeItem } from '../../interface/controle-qualidade';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { Zpr } from 'src/app/interface/zpr';

@Component({
  selector: 'app-controle-qualidade-lista',
  templateUrl: './controle-qualidade-lista.component.html',
  styleUrls: ['./controle-qualidade-lista.component.css']
})
export class ControleQualidadeListaComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroControleQualidadeLista;

  codigoEditar: string = "";
  motivoEditar: string = "";

  zprAdvancedFilters: Array<PoDynamicFormField>;
  zprColumnsFilters: Array<PoLookupColumn>;
  zprFieldFormaterFilters: (value: Zpr) => string;

  varStatus: Array<PoSelectOption>;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  constructor(
    private router: Router,
    private romaneioService: RomaneioService,
    private poStorageService: PoStorageService,
    private poDialogService: PoDialogService,
    private excelService: ExcelService,
    private poNotificationService: PoNotificationService,
    public zprService: ZprLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroControleQualidadeLista(this.poStorageService);

    this.varStatus = this.listaStatus();
    this.formatExtended = PoDatepickerIsoFormat.Extended;

    this.zprService.grupo        = 'MOTQUALID';
    this.zprAdvancedFilters      = this.zprService.getAdvancedFilter();
    this.zprColumnsFilters       = this.zprService.getColumnsFilterCompleto();
    this.zprFieldFormaterFilters = this.zprService.getFieldFormater;
  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('modalEditar', { static: true }) modalEditar!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad();
  }

  public readonly actions: Array<PoPageAction> = [
    { label: 'Novo', action: this.novoCadastro.bind(this) },
    { label: 'Gerar Excel', action: this.gerarExcel.bind(this) },
  ];

  novoCadastro(): void {
    this.router.navigateByUrl('/estoque/romaneio/controle-qualidade/cadastro');
  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.romaneioService.getControleQualidadeLista(this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items.map((item) => {
        return { ...item, favorite: ['editar','excluir'] };
      });
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CZ04CODIGO' , label: 'Código'           , width: '100px'},
    {property: 'CZ04LOTE'   , label: 'Lote'             , width: '100px'},
    {property: 'CSB8PRODUTO', label: 'Produto'          , width: '200px'},
    {property: 'CSB1DESC',    label: 'Desc. Produto'    , width: '200px'},
    {property: 'DZ04DATA'   , label: 'Data'             , width: '100px', type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CZ04HORA'   , label: 'Hora'             , width: '100px'},
    {property: 'CZ04TURNO'  , label: 'Turno'            , width: '100px'},
    {property: 'CZ04STATUS' , label: 'Status'           , width: '100px', type: 'label',
      labels: [
        { value: 'A', color: 'color-01',  label: 'Aprovado'    },
        { value: 'R', color: 'color-05',  label: 'Recusado' },
      ]
    },
    {property: 'CZPRGENERI' , label: 'Motivo'         , width: '200px'},
    {property: 'CZ04USER'   , label: 'Usuário'         , width: '100px'},
    {property: 'CUSRNOME'   , label: 'Nome Usuário'    , width: '150px'},
    {property: 'favorite'  , label: '...'             , width: '100px' , type: 'icon',
      icons: [
        {
          action: this.editarAction.bind(this),
          icon: 'po-icon-edit',
          tooltip: 'Editar',
          value: 'editar',
          disabled: this.disableEditar.bind(this)
        },
        {
          action: this.excluirAction.bind(this),
          icon: 'po-icon-delete',
          tooltip: 'Excluir',
          value: 'excluir',
        }
      ]
    }
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Controle de Qualidade', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };


  listaStatus(): Array<PoSelectOption> {
    return [
      { value: "" , label: "Ambos"    },
      { value: "A", label: "Aprovado" },
      { value: "R", label: "Recusado" },
    ];
  }

  editarAction(row: ControleQualidadeItem): void {
    this.codigoEditar = row.CZ04CODIGO;
    this.motivoEditar = row.CZ04MOTIVO;
    this.modalEditar.open();
  }

  public readonly modalEditarAction: PoModalAction = {
    action: () => {
      if (this.motivoEditar != '') {
        this.modalEditar.close();
        this.romaneioService.putControleQualidade(this.codigoEditar, this.motivoEditar.trim()).subscribe((ret) => {
          this.poNotificationService.success("Motivo alterado com sucesso!");
          this.tabelaPrincipalLoad();
        });
      } else {
        this.poNotificationService.error("Por favor, preencha o motivo da rejeição!");
      }
    },
    label: 'Alterar Motivo'
  };

  disableEditar(row: ControleQualidadeItem): boolean {
    return row.CZ04STATUS != 'R';
  }

  excluirAction(row: ControleQualidadeItem): void {
    this.poDialogService.confirm({
      title: 'Excluir Item',
      message: 'Deseja realmente excluir este item do controle de qualidade?',
      confirm: () => this.excluirItem(row)
    });
  }

  excluirItem(row: ControleQualidadeItem ): void {
    this.romaneioService.deleteItemControleQualidade(row.CZ04CODIGO).subscribe( () => {
      this.tabelaPrincipalLoad();
    });
  }

  gerarExcel(): void {
    const lista_excel = this.tabelaPrincipalItens.map( (item) => {
      return{
        'Código'        :  item.CZ04CODIGO,
        'Lote'          :  item.CZ04LOTE,
        'Produto'       :  item.CSB8PRODUTO,
        'Desc. Produto' :  item.CSB1DESC,
        'Data'          :  item.DZ04DATA,
        'Hora'          :  item.CZ04HORA,
        'Turno'         :  item.CZ04TURNO,
        'Status'        :  item.CZ04STATUS == 'A' ? "Aprovado" : "Rejeitado",
        'Motivo'        :  item.CZPRGENERI,
        'Usuário'       :  item.CZ04USER,
        'Nome Usuario'  :  item.CUSRNOME,
      }
    });

    this.excelService.exportAsExcelFile(lista_excel, `Relatório Controle Qualidade`);
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };

}
